export default {
    lavender: [
        {name: 'nightHuntRitualFamiliarity', type: 'base', value: 0.03}
    ],
    mapleLeaf: [
        {name: 'nightHuntRitualHintChance', type: 'base', value: 0.1}
    ],
    fourLeafClover: [
        {name: 'nightHuntRitualSuccessChance', type: 'base', value: 0.08}
    ],
    charredSkull: [
        {name: 'nightHuntRitualStability', type: 'base', value: 0.12}
    ],
    mysticalWater: [
        {name: 'nightHuntRitualSuccessChance', type: 'base', value: 0.06},
        {name: 'nightHuntRitualStability', type: 'base', value: 0.05}
    ],
    cheese: [
        {name: 'nightHuntRitualFamiliarity', type: 'base', value: 0.05},
        {name: 'nightHuntRitualSuccessChance', type: 'base', value: -0.18},
        {name: 'nightHuntRitualStability', type: 'base', value: -0.05}
    ],
    spiderWeb: [
        {name: 'nightHuntRitualFamiliarity', type: 'base', value: 0.01},
        {name: 'nightHuntRitualStability', type: 'base', value: 0.1}
    ],
    strangeEgg: [
        {name: 'nightHuntRitualHintChance', type: 'base', value: 0.075},
        {name: 'nightHuntRitualSuccessChance', type: 'base', value: 0.05}
    ],
    puzzlePiece: [
        {name: 'nightHuntRitualHintChance', type: 'base', value: 0.14},
        {name: 'nightHuntRitualStability', type: 'base', value: -0.03}
    ],
    wizardHat: [
        {name: 'nightHuntRitualStability', type: 'base', value: 0.04},
        {name: 'nightHuntRitualSuccessChance', type: 'base', value: 0.04},
        {name: 'nightHuntRitualHintChance', type: 'base', value: 0.04},
        {name: 'nightHuntRitualFamiliarity', type: 'base', value: 0.01}
    ],
    cactus: [
        {name: 'nightHuntRitualStability', type: 'base', value: -0.05},
        {name: 'nightHuntRitualSuccessChance', type: 'base', value: 0.15}
    ],
    feather: [
        {name: 'nightHuntRitualFamiliarity', type: 'base', value: 0.02},
        {name: 'nightHuntRitualHintChance', type: 'base', value: 0.05}
    ]
}
